import { getAssets } from "@unisearch/helpers";
import Image from "next/legacy/image";
import { FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import { GrFacebookOption } from "react-icons/gr";
import { MdEmail } from "react-icons/md";
import { ReactSVG } from "react-svg";
import styles from "./hero.module.scss";

export const ComingSoonHero = () => {
  return (
    <section className={styles.section_commingsoon}>
      <div className={styles.hero_wrapper}>
        <Image
          src={getAssets("assets/logo-beta.webp")}
          alt="UniSearch Logo"
          blurDataURL={getAssets("assets/logo-beta.webp")}
          placeholder="blur"
          width={186}
          height={30}
        />
        <h2 className={styles.hero_subheading}>WE'RE LAUNCHING OUR</h2>
        <h1 className={styles.hero_heading}>WEBSITE</h1>
        <div className={styles.short_description}>
          The Comprehensive Toolkit for Every Stage of Study Abroad
          <br /> Bringing international student experience and intelligent
          technology together <br /> to make study abroad solutions simpler than
          ever
        </div>

        <div className={styles.social_links_wrapper}>
          <ul>
            <li>
              <a href="mailto:info@myunisearch.com">
                <MdEmail />
              </a>
            </li>
            <li>
              <a
                rel="nofollow"
                target="_blank"
                href="https://twitter.com/myunisearch"
              >
                <FaTwitter />
              </a>
            </li>
            <li>
              <a
                rel="nofollow"
                target="_blank"
                href="https://www.facebook.com/UniSearchMalaysia"
              >
                <GrFacebookOption />
              </a>
            </li>
            <li>
              <a
                rel="nofollow"
                target="_blank"
                href="https://www.youtube.com/channel/UCCHQrxOr5olDBxypJUE7qZw"
              >
                <FaYoutube />
              </a>
            </li>
            <li>
              <a
                rel="nofollow"
                target="_blank"
                href="https://www.instagram.com/myunisearch"
              >
                <FaInstagram />
              </a>
            </li>
          </ul>
        </div>

        <a href="#form" className={styles.arrow_down}>
          <ReactSVG src={getAssets("assets/icons/arrow-down-big.svg")} />
        </a>
      </div>
    </section>
  );
};

export default ComingSoonHero;
